import { useAttributes } from './context.tsx'

export default useAttributes
